import { render } from "./GeneratorCard.vue?vue&type=template&id=12e930eb"
import script from "./GeneratorCard.vue?vue&type=script&lang=js"
export * from "./GeneratorCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\led2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__